/* global jwplayer */
import React from 'react';
import Tabs from '../Tabs.js';
import initJWPlayerMux from '@mux/mux-data-jwplayer';

export default class Jwplayer extends React.Component {

  player;
  resized = false;

  componentDidMount() {
   
    this.player = jwplayer("player");
    
    
    console.log(this.props.streamingUrl);
    let url = this.props.streamingUrl;
    
    let prefix = 'wowzaplay'
    if(window.live)
      prefix = 'wowzadvrplaylist';
    
    let params = [];
    if (window.query && window.query.s)
      params.push(prefix + 'start=' + window.query.s * 1000);
    if (window.query && window.query.e) {
      let duration = window.query.e - window.query.s;
      params.push(prefix + 'duration=' + duration * 1000);
    }
	
	if(window.vod && window.query.s) {
		let urlA = url.split('/master.m3u8').shift();
		url = urlA + '/clipFrom/' + (window.query.s * 1000) + '/clipTo/' + (window.query.e * 1000) + '/master.m3u8';
	}
	
    if (params.length > 0 && url.indexOf('?') == -1)
      url += '?' + params.join('&')
    else if (params.length > 0)
      url += '&' + params.join('&')
    
    
    
    let setup = {
      file: url,
      width: '100%'
    };
    
    window.onresize = () => {
      this.checkPlayerHeight();
    };
    
    if(window.custom)
      setup = Object.assign(window.custom, setup);
    
     if(window.subtitles)
      setup = Object.assign({
        tracks: [{ 
            file: window.subtitles, 
            label: "Sous titres",
            kind: "captions",
            "default": true 
        }]
        
      }, setup);   
    console.log('setup', setup)
    //setup.image = 'https://assets-jpcust.jwpsrv.com/thumbnails/maju5h8j-1280.jpg';
	
	if(window.jwsharing)
		setup.sharing = window.jwsharing;
	
    this.player.setup(setup);
	
	const playerInitTime = initJWPlayerMux.utils.now();
	initJWPlayerMux(this.player, {
		debug: false,
		data: {
			env_key: 'npttlogqi2e7ip7img2fq80sv', // required	
	
			// Metadata
			player_name: 'Synople player',
			player_init_time: playerInitTime,
			video_id: window.programId, 
			video_series: window.channelId,
			video_stream_type: window.live ? 'live':'on-demand'
		}
	}, window.jwplayer);
    
    window.sdk.player(this.player);
    
    /*let hideSlidebar = false;
    if(window.live && window.query && window.query.s) {
        window.sdk.player().startAt(window.query.s);
        hideSlidebar = true;
    }
    if(window.live && window.query && window.query.e) {
      window.sdk.player().stopAt(window.query.e)
      hideSlidebar = true;
    }*/
    let hideSlidebar = false
    
    this.player.on('error', () => {
      if(window.live) {
        window.sdk.isLive = {
          live : false
        }
        document.querySelector('.jw-overlays.jw-reset').style.backgroundImage = 'url(' + setup.image + ')';
        document.querySelector('.jw-overlays.jw-reset').style.backgroundPosition = 'center';
        document.querySelector('.jw-overlays.jw-reset').style.backgroundRepeat = 'no-repeat';
        document.querySelector('.jw-overlays.jw-reset').style.backgroundSize = 'contain';
        document.querySelector('.jw-error-text.jw-reset-text').innerHTML = 'Pas de live actuellement';
        window.sdk.live.isLive = {
          live: false
        }
        setTimeout(() => {
          this.checkPlayerHeight();
        }, 500)
      }
    });
    
    
    
    this.playerDurationNotified = false;
    this.player.on('play', () => {
      
      document.querySelector('.jw-overlays.jw-reset').style.backgroundImage = 'none';
      //document.querySelector('.jw-overlays.jw-reset').style.backgroundPosition = 'center';
      //document.querySelector('.jw-overlays.jw-reset').style.backgroundRepeat = 'no-repeat';
      //document.querySelector('.jw-overlays.jw-reset').style.backgroundSize = 'contain';
      
      if(window.live) {
        window.sdk.live.isLive = {
          live: true
        }
      }
      if(!this.playerDurationNotified) {
        this.playerDurationNotified = true;
        let i = setInterval(() => {
          if(window.sdk.player().getRealDuration() > -15) {
            window.sdk.emit('play');
            clearInterval(i);
          }
        }, 300)
      }
      if(window.live) {
        window.sdk.isLive = {
          live : true
        }
      }
    });
    
    this.player.on('ready', () => {
      
      //disable on ios smartphone
      if(!this.fullscreenBlocked) {
        this.fullscreenBlocked = true;
        var fullScreenBtns = document.getElementsByClassName('jw-icon-fullscreen');
        /*for(var i in fullScreenBtns){
            var btn = fullScreenBtns[i];
            btn.onclick = (e) => {
                this.player.setAllowFullscreen(false);
                e.preventDefault();
                e.stopPropagation();
                alert('Full screen is blocked');
                return false;
            };
        }*/
      }
      
      var playerContainer = this.player.getContainer();
      var buttonContainer = playerContainer.querySelector('.jw-button-container');
      
      if(hideSlidebar) {
        playerContainer.querySelector('.jw-slider-time').style.display = 'none';
        playerContainer.querySelector('.jw-text-elapsed').style.display = 'none';
        playerContainer.querySelector('.jw-icon-inline.jw-text-duration').style.display = 'none !important';
        playerContainer.querySelector('.jw-icon-inline.jw-text-duration').style.visibility = 'hidden';
      }
      
      if(window.custom) {
        if(window.custom.buttons.forward.enable) {
          var forward = document.createElement("div");
          forward.innerHTML = '<i class="material-icons">fast_forward</i>';
          forward.setAttribute('class', 'jw-icon jw-icon-inline jw-button-color jw-reset jw-icon-forward');
          forward.setAttribute('onclick', 'window.sdk.player().forward(window.custom.buttons.forward.value)');
        
          buttonContainer.insertBefore(forward, buttonContainer.childNodes[2]);
        }
        
        var rewind = document.querySelector('.jw-icon-inline.jw-icon-rewind');
        if(window.custom.buttons.rewind.enable) {
          rewind.innerHTML = '<i class="material-icons">fast_rewind</i>';
          rewind.setAttribute('onclick', 'window.sdk.player().rewind(window.custom.buttons.rewind.value)');
        }
        else {
          rewind.parentNode.removeChild(rewind);
        }
      }
      
      this.checkPlayerHeight();
      
      
      let tabs = document.querySelector('#player-wrapper .right');
      if (document.getElementById('player')) {
        try {
          document.getElementById('player').appendChild(tabs);
        }
        catch(err) {
          
        }
      }
    });
    

  }
  
  checkPlayerHeight() {
    //console.log(document.getElementById('player').offsetWidth, document.getElementById('player').offsetHeight, window.innerWidth, window.innerHeight, (document.getElementById('player').offsetHeight / window.innerHeight))
    if((document.getElementById('player').offsetHeight / window.innerHeight) > 0.364 && window.innerHeight > window.innerWidth) {
        this.player.resize(window.innerWidth, (window.innerHeight * 0.363));
        this.resized = true;
    }
    else if(this.resized) {
      this.player.resize('100%', '100%');
      this.resized = false;
    }
    
  }

  render() {
    return (
      <div id="player-wrapper">
        <div id="player"></div>
        { window.sdk.showTab() && window.sdk.isOverlay() &&
          <div className="right">
            <Tabs />
          </div>
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/Player/MediaPlayer/Jwplayer.js